import { request } from 'undici'

export interface SizeData {
	bytes: number
	color: `#${ string }`
	files: number
	pretty: string
}

export interface ResponseV1 {
	installSize: number
	publishSize: number
}

export interface ResponseV2 {
	install: SizeData
	name: string
	publish: SizeData
	version: string
}

class PackageError extends Error {
	public constructor( pkg: string ) {
		super( `Couldn't find package: ${ pkg }` )
	}
}

function packagephobia( pkg: string, version: 1 ): Promise<ResponseV1>
function packagephobia( pkg: string, version?: 2 ): Promise<ResponseV2>
async function packagephobia( pkg: string, version: 1 | 2 = 2 ): Promise<ResponseV1 | ResponseV2> {
	const api = `https://packagephobia.com/${ version === 2 ? 'v2/' : '' }api.json`
	const { body, statusCode } = await request( `${ api }?p=${ pkg }` )
	if ( statusCode !== 200 ) throw new PackageError( pkg )
	return body.json()
}

export default packagephobia